import { Injectable } from '@angular/core';
import { AccountFactory, BackupFactory, BroadcastFactory, CertificateFactory, SettingFactory, UpdateFactory } from '../../models';
import { IFactoryRepository, IModelFactory } from './factory.interface';

@Injectable({ providedIn: 'root' })
export class FactoryRepository {
  private readonly models: IFactoryRepository = {
    AccountFactory,
    BackupFactory,
    BroadcastFactory,
    CertificateFactory,
    SettingFactory,
    UpdateFactory,
  };

  public getModel(modelName: string): IModelFactory {
    return this.models[modelName];
  }
}
